import { em } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";
import { uiStore } from "@/mobx/rootStore";

export function useHandleNavigate() {
	const navigate = useNavigate();
	const isMobile = useMediaQuery(`(max-width: ${em(750)})`);

	function handleNavigate(_path) {
		if (isMobile) {
			uiStore.closeMobileNavbar();
		}

		navigate(_path);
	}

	return {
		handleNavigate,
	};
}
